/* eslint-disable custom-eslint-rules/force-logicalOperandsMustBeBoolean */
import { useToasts } from "react-toast-notifications";
import { Toast } from "../../../Toast/Toast.component.js";
import { CloseAllToasts } from "../CloseAllToasts/index.js";
import { isFirstToast } from "./helpers/isFirstToast.js";
import { StyledToastContainer } from "./styles.js";
import { BuildCustomToastParams, CustomToastProps } from "./types.js";

export const buildCustomToast = ({ closeAllText, allowCloseAll = true }: BuildCustomToastParams) => {
    return (props: CustomToastProps) => {
        const { toastStack, removeAllToasts } = useToasts();

        const hasOwnCloseButton = props.autoDismiss === false;

        return (
            <StyledToastContainer size={props.size || "regular"}>
                {!hasOwnCloseButton &&
                    isFirstToast({
                        allowCloseAll,
                        toastContent: props.children,
                        toastStack,
                    }) && (
                        <CloseAllToasts
                            text={closeAllText}
                            onClose={() => {
                                removeAllToasts();
                            }}
                        />
                    )}
                <Toast {...props} />
            </StyledToastContainer>
        );
    };
};
